import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMutation } from 'data-fetching-client';
import { addAlert } from '../../../utils/alerts';
import { useTracker } from '../../../utils/usageTracker';
import { RESUME_SUBSCRIPTION } from './resumeSubscriptionApi';
import { useNotificationsQuery } from '../hooks/useNotificationsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function useResumeSubscription({
  objectId,
  proposedNextBillingDate,
  onClose
}) {
  const {
    trackPauseChange
  } = useTracker();
  const {
    sendEmailForSubscriptionPaused
  } = useNotificationsQuery();
  return useMutation(RESUME_SUBSCRIPTION, {
    variables: {
      objectId,
      proposedNextBillingDate
    },
    fetchPolicy: 'network-only',
    onCompleted: () => {
      trackPauseChange({
        subType: 'pause',
        action: 'resumeSubscriptionModalSubmitted',
        status: 'RESUMED'
      });
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ResumeSubscriptionModal.successfullyResumedTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: sendEmailForSubscriptionPaused ? 'subscriptions.ResumeSubscriptionModal.successfullyResumedMessageNotify' : 'subscriptions.ResumeSubscriptionModal.successfullyResumedMessageNoNotify'
        }),
        type: 'success'
      });
      onClose();
    },
    onError: () => {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ResumeSubscriptionModal.errorResumingTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ResumeSubscriptionModal.errorResumingMessage"
        }),
        type: 'danger'
      });
      onClose();
    }
  });
}